<template>

  <el-main
    class="main_content"
    style="padding: 0"
  >
    <div class="cont_navs_header">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>
          <a>商品管理</a>
        </el-breadcrumb-item>
        <el-breadcrumb-item>
          <a @click="jumpTo('/skuList')">商品关联规格列表</a>
        </el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div class="contain_div">
      <ul class="cont_btns1">
        <li>
          <el-button
            @click="backGoodList"
            type="primary"
          >返回商品列表</el-button>
        </li>
      </ul>
      <div class="contain_header clr">
        <el-form
          :inline="true"
          class="m-search"
          size='small'
          :model="filters"
        >
          <el-form-item label='当前商品:'>
            <el-tag type="success">{{goodName}}</el-tag>
          </el-form-item>

          <el-form-item>
            <el-button
              type="primary"
              @click="handleSearch"
            >搜索</el-button>
            <el-button
              type="success"
              @click="addPostDialog"
            >新增</el-button>
          </el-form-item>
        </el-form>
      </div>

      <div class="contain_body">
        <div class="contain_body_head">
        </div>
        <el-table
          :data="tableData"
          :height="tableHeight"
          style="width: 100%"
          :header-cell-class-name='objectSpanMethod'
        >
          <el-table-column
            prop="id"
            label="编号"
          >
          </el-table-column>
          <el-table-column
            label="规格名称"
            prop="property"
          >
          </el-table-column>
          <el-table-column
            label="商品名称"
            prop="good_name"
          >
          </el-table-column>
          <el-table-column
            label="操作"
            width="100"
          >
            <template slot-scope="scope">
              <el-button
                @click="upHouseStatus(scope.row, 3)"
                type="text"
                size="small"
              >删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="pageDiv block">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page.sync="page_num"
            :page-count='total_page'
            :page-size="page_size"
            layout="total, prev, pager, next"
            :total="total_num"
          >
          </el-pagination>
        </div>
      </div>

    </div>

    <el-dialog
      title="新增商品关联规格"
      :visible.sync="dialogAddVisible"
      width="40%"
    >

      <el-form
        label-position="top"
        class="m-search"
        size='small'
        :model="form"
        ref="form"
        :rules="addFormRule"
      >
        <el-form-item
          label="规格"
          v-loading="loading"
        >
          <el-select
            v-model="form.propertyNameId"
            placeholder="请选择规格"
          >
            <el-option
              v-for="option in typeOptions"
              :value="option.id"
              :key='option.id'
              :label="option.property"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            @click="addPost()"
            :loading="addLoading"
          >新增</el-button>
          <el-button @click="dialogAddVisible = false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>

  </el-main>
</template>


<script>
import { bus } from "../../bus.js";
import API from "../../api/api_user";
export default {
  name: "goodPropertyList",
  created() {},

  data() {
    return {
      goodName: null,
      goodId: null,
      addFormRule: {
        propertyNameId: [
          { required: true, message: "请选择规格", trigger: "blur" }
        ]
      },
      addLoading: false,
      loading: false,
      form: {
        propertyNameId: null
      },
      dialogEditVisible: false,
      filters: {
        status: null,
        keyword: null,
        pid: null
      },
      isCollapse: true,
      activeName: "second",
      dialogAddVisible: false,
      backFirst: 1,
      page_num: 1,
      keywords: "",
      value4: "",
      pickerOptions1: 1,
      value2: "",
      options: [{ text: "待上架", value: "1" }, { text: "上架", value: "2" }],
      typeOptions: null,
      tableData: [],
      total_num: 0,
      total_page: 0,
      page_size: 10,
      tableHeight:null
    };
  },
  mounted() {
    this.tableHeight = document.documentElement.clientHeight - 330;
    this.goodName = this.$route.query.goodName;
    this.goodId = this.$route.query.goodId;
    this.page_num = 1;
    this.handleSearch();
  },
  methods: {
    backGoodList() {
      this.$router.push({
        path: "/goodList"
      });
    },
    beforeAvatarUpload: function(e) {},
    handleAvatarSuccess: function(e) {
      if (e.key == 1000) {
        this.form.listPic = e.result.map.path;
        this.$message.success({
          showClose: true,
          message: "上传成功",
          duration: 1500
        });
      }
    },
    addPost() {
      let that = this;
      that.$refs["form"].validate(valid => {
        if (valid) {
          let para = Object.assign({}, that.form);
          para.token = localStorage.getItem("api_token");
          para.goodId = that.goodId;
          that.addLoading = true;
          API.add_good_property(para)
            .then(
              function(result) {
                that.$refs["form"].resetFields();
                if (result.key == 1000) {
                  that.$message.success({
                    showClose: true,
                    message: "新增成功",
                    duration: 1500
                  });

                  that.search();
                } else {
                  that.$message.error({
                    showClose: true,
                    message: result.message || "登录失败",
                    duration: 2000
                  });
                }
                that.dialogAddVisible = false;
                that.addLoading = false;
              },
              function(err) {
                that.dialogAddVisible = false;
                that.addLoading = false;
                that.$message.error({
                  showClose: true,
                  message: err.toString(),
                  duration: 2000
                });
              }
            )
            .catch(function(error) {
              that.dialogAddVisible = false;
              that.addLoading = false;
              that.$message.error({
                showClose: true,
                message: "请求出现异常",
                duration: 2000
              });
            });
        }
      });
    },
    addPostDialog() {
      this.form.propertyNameId = null;
      this.dialogAddVisible = true;
      var that = this;
      var params = {
        token:localStorage.getItem("api_token"),
        pageNum:1,
        pageSize:100,
        goodId:this.goodId
      };
      API.property_name_list(params)
        .then(
          function(result) {
            that.loading = false;
            if (result.key == 1000) {
              if (result.result.list && result.result.list.length > 0) {
              }
              that.typeOptions = result.result.list;
            }
          },
          function(err) {
            that.loading = false;
            that.$message.error({
              showClose: true,
              message: err.toString(),
              duration: 2000
            });
          }
        )
        .catch(function(error) {
          that.loading = false;
          that.$message.error({
            showClose: true,
            message: "请求出现异常",
            duration: 2000
          });
        });
    },
    upHouseStatus(row, status) {
      let that = this;
      var m1 = "";
      var m2 = "";
      var m3 = "";
      var type = "";
      m1 = "确定删除该商品规格吗？";
      m2 = "删除成功后，app和后台都不显示该规格";
      m3 = "删除成功";
      type = "error";
      this.$confirm(m1, m2, { type: type })
        .then(() => {
          that.loading = true;
          let para = {
            token: localStorage.getItem("api_token"),
            id: row.pro_id
          };
          API.del_good_property(para)
            .then(
              function(result) {
                that.loading = false;
                if (result && parseInt(result.key) === 1000) {
                  that.$message.success({
                    showClose: true,
                    message: m3,
                    duration: 1500
                  });
                  that.search();
                }
              },
              function(err) {
                that.loading = false;
                that.$message.error({
                  showClose: true,
                  message: err.toString(),
                  duration: 2000
                });
              }
            )
            .catch(function(error) {
              that.loading = false;
              that.$message.error({
                showClose: true,
                message: "请求出现异常",
                duration: 2000
              });
            });
        })
        .catch(() => {});
    },
    handleSearch() {
      this.page_size = 10;
      this.page_num = 1;
      this.search();
    },
    search() {
      let that = this;
      let params = {
        pageNum: that.page_num,
        pageSize: that.page_size,
        token: localStorage.getItem("api_token"),
        goodId: that.goodId
      };
      if (
        that.filters.keyword &&
        that.filters.keyword != null &&
        that.filters.keyword != ""
      ) {
        params.keyword = that.filters.keyword;
      }
      that.loading = true;
      API.good_property_list(params)
        .then(
          function(result) {
            that.loading = false;
            if (result.key == 1000) {
              that.total_num = result.result.count;
              that.total_page = result.result.allPageNumber;
              if (result.result.list && result.result.list.length > 0) {
              }
              that.tableData = result.result.list;
            }
          },
          function(err) {
            that.loading = false;
            that.$message.error({
              showClose: true,
              message: err.toString(),
              duration: 2000
            });
          }
        )
        .catch(function(error) {
          that.loading = false;
          that.$message.error({
            showClose: true,
            message: "请求出现异常",
            duration: 2000
          });
        });
    },
    jumpTo(url) {
      this.$router.push(url); //用go刷新
    },
    handleOpen(key, keyPath) {},
    handleClose(key, keyPath) {},
    handleClick(tab, event) {},
    objectSpanMethod({ row, rowIndex }) {
      return "table_head";
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      this.search();
    }
  }
};
</script>

<style>
.table_head {
  background-color: #f8f8f8 !important;
  border-right: 1px solid #eee;
  border-bottom: 1px solid #eee;
  border-top: 1px solid #eee;
}

.main_content {
  position: absolute;
  left: 210px;
  top: 105px;
  right: 0;
  bottom: 0;
  background-color: #f2f2f2;
  padding: 0;
}

.cont_navs {
  background-color: #fff;
  width: 100%;
  height: 55px;
  box-sizing: border-box;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1);
  text-align: center;
  margin-bottom: 20px;
}
.cont_navs li {
  display: inline-block;
  line-height: 21px;
  padding: 17px 0;
  margin: 0 20px;
  height: 55px;
  color: #bbb;
  font-size: 15px;
  text-align: center;
  cursor: pointer;
}
.cont_navs li:hover {
  color: #409eff;
}

.ac_li {
  color: #409eff;
  border-bottom: solid 2px #409eff;
}
.contain_div {
  margin: 10px;
}
.cont_btns1 {
  float: left;
  margin: 0px 0px 20px 0;
}
.contain_header {
  background-color: #fff;
  padding: 10px;
}
.cont_btns1 li {
  display: inline-block;
}

.contain_body {
  background-color: #fff;
  margin-top: 20px;
  position: relative;
  padding-bottom: 35px;
}
.contain_body_head {
  display: block;
  padding: 10px 0 10px 10px;
  font-size: 16px;
  background-color: #f8f8f8;
}
.pageDiv {
  position: absolute;
  right: 0;
  bottom: 0;
}

.m-search {
  margin-bottom: -15px;
}
.el-button + .el-button {
  margin-left: 0px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/good/goodPropertyList.vue